const Getters = {
  getOftenUseListFromState: (state) => {
    return state.oftenUseList
  },
  getCurrentOftenUseScreenIdsFromState: (state) => {
    return state.oftenUseList.map((item) => item.oftenUseScreenId)
  }
}

export default Getters
